import {
  AiMessageFeedbackEnum,
  AiMessageFeedbackReasonEnum,
  useAiMessageFeedbackCreateMutation,
  useAiMessageFeedbackDestroyMutation,
} from 'graphql-common';
import { logger } from '@lib/services/logger';

// Wraps the message-rating mutations. Each mutation returns the updated
// AiMessage (with the feedback* fields), and Apollo normalises by id, so the
// rendered thumb reconciles from the cache automatically — no manual refetch.
export default function useAiMessageFeedback() {
  const [createMutation, createResult] = useAiMessageFeedbackCreateMutation();
  const [destroyMutation, destroyResult] =
    useAiMessageFeedbackDestroyMutation();

  // Like → POSITIVE (no reason); dislike → NEGATIVE with a required reason and
  // an optional comment. Creating the opposite rating replaces the previous one
  // server-side.
  const submitFeedback = (
    id: string,
    feedback: AiMessageFeedbackEnum,
    reason?: AiMessageFeedbackReasonEnum,
    comment?: string,
  ) => {
    logger.debug('AiAssistant: submitting message feedback', { id, feedback });
    return createMutation({
      variables: { id, attributes: { feedback, reason, comment } },
    }).catch((error) => {
      logger.error('AiAssistant: submit message feedback failed', {
        id,
        error,
      });
      throw error;
    });
  };

  const removeFeedback = (id: string) => {
    logger.debug('AiAssistant: removing message feedback', { id });
    return destroyMutation({ variables: { id } }).catch((error) => {
      logger.error('AiAssistant: remove message feedback failed', {
        id,
        error,
      });
      throw error;
    });
  };

  return {
    submitFeedback,
    removeFeedback,
    feedbackLoading: createResult.loading || destroyResult.loading,
  };
}
